import GeneralMixin from './GeneralMixin';

export default {
    mixins: [
        GeneralMixin,
    ],
    components: {
        HelpSpan: () => import(/* webpackChunkName: "help-span" */ '@/components/form/HelpSpan.vue'),
    },
    props: {
    },
    data() {
        return {
            form: {
                id: null,
            },
            lists: {
                loaded: false,
                onoff: [{'id': 1, 'name': 'Sim', 'code': 1}, {'id': 2, 'name': 'Não', 'code': 0}],
            },
        }
    },
    mounted() {
        this.loadLists();
    },
    methods: {
        loadLists: function() {
            if (!this.lists.loaded && this.url.getLists) {
                this.$http.get(this.url.getLists)
                .then(res => {
                    let data = res.data ? res.data : res;
                    Object.keys(data).forEach(key => {
                        if(key in this.lists) {
                            this.lists[key] = data[key];
                        }
                    });
                    this.lists.loaded = true;
                    this.activeTooltip();
                })
                .catch(error => {
                    this.lists.loaded = false;
                    this.showHttpError(error);
                });
            }
        },
        reset(){
            Object.assign(this.$data.form, this.$options.data().form);
        },

    },
};
